import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { NgxAimViewStationGroupsClass } from './ngx-aim-viewstation-groups.class';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { FloatLabelModule } from 'primeng/floatlabel';
import { StationImagePipe } from '../../../pipes';

@Component({
  selector: 'ngx-aim-view-station-groups',
  standalone: true,
  imports: [
    DropdownModule,
    FormsModule,
    RouterLink,
    ProgressSpinnerModule,
    FloatLabelModule,
    StationImagePipe,
  ],
  templateUrl: './ngx-aim-view-station-groups.component.html',
  styleUrl: './ngx-aim-view-station-groups.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NgxAimViewStationGroupsComponent extends NgxAimViewStationGroupsClass implements OnInit {
  ngOnInit() {
    this.init();
  }
}
